import type { LegendItem } from '../../ResponsiveLegend/ResponsiveLegend.types';
import type { ChartWidgetProps } from '../ChartWidget.types';
import type { LinesProps } from '../../AxisAndGrid/AxisAndGrid.types';

/** Legend entries come from the full dataset so selection never removes its own controls. */
export const prepareLegend = (props: ChartWidgetProps): LegendItem[] => {
  if (props.legend_items) return props.legend_items;
  const key = props?.grouping_key;
  if (!key) return [];
  const groups = new Map<string, LegendItem>();
  for (const row of props.data ?? []) {
    const value = row[key];
    if (typeof value !== 'string' && !(typeof value === 'number' && Number.isFinite(value))) continue;
    const label = String(value);
    if (groups.has(label)) continue;
    const color = row[props.color_key ?? 'color'];
    groups.set(label, { ...row, label,
      color: (props.lines as LinesProps | undefined)?.[label]?.color ?? props.colors?.[label] ?? (typeof color === 'string' ? color : props.color),
      value: undefined,
      unit: typeof row.unit === 'string' ? row.unit : props.unit,
    });
  }
  return [...groups.values()];
};
